function hasInvalidCharactersInSctiptName(scriptName) {
    return !/^[a-zA-Z0-9._-]+$/.test(scriptName);
}

export default hasInvalidCharactersInSctiptName;